import { appConfig } from '../../../config/config.app';
import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export type MlifeVerificationRequest = {
  login: string;
  dob: string;
  mlifeNumber?: string;
  partner?: { name: string; tokenKey: string };
};

export type MlifeVerificationResponse = {
  activationKid: string;
};

export const mlifeVerificationRequest = async (requestBody: MlifeVerificationRequest, aroIdMeStepUpEnabled = false) => {
  try {
    const result = await post(
      '/guest/activate',
      { body: JSON.stringify(requestBody) },
      appConfig.apiUrl,
      true,
      true,
      false,
      aroIdMeStepUpEnabled,
    );

    evaluateResponseErrorCode(result.response);

    return result.response as MlifeVerificationResponse;
  } catch (error) {
    throw getApiError(error);
  }
};
